export default __webpack_public_path__ + "static/media/ok.eeb06aaa.svg";